import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";

export default class ItemsPadding extends BaseOption {
  static userInterfaceComponent = {
    label: "Items Padding",
    component: inspectorTools.SIMPLE_INPUT,
    props: {
      inputType: "number",
      min: 0,
      append: "px",
    },
  };

  static defaultValue = 0;

  static convertConfigValueToCompiledValue(configValue) {
    return configValue;
  }
}
